export default __webpack_public_path__ + "static/media/background01.d19dd742.jpg";